import styled, { css } from 'styled-components';
import { HiddenElement } from '@/styles/helpers';
import { Header as HeaderComponent } from '@/components/Header/Header';
import type { AdsSectionLayoutScope } from '@/components/AdsSection/AdsSection.types';
import { SkeletonLoader } from '@/components/SkeletonLoader/SkeletonLoader';
import { Breadcrumbs as BreadcrumbsComponent } from '@/components/Breadcrumbs/Breadcrumbs';
import { DesktopFooter as DesktopFooterComponent } from '@/components/Footer';

export const Header = styled(HeaderComponent)`
  border-bottom: none;
`;

const wrapperStyles = css`
  display: flex;
  justify-content: center;
  width: 100%;
  padding: 0 30px;
  background: ${({ theme }) => theme.palette.primary.background};

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    padding: 0;
  }
`;

const containerStyles = css<{ $isVipAds: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: 1280px;

  ${({ $isVipAds }) =>
    $isVipAds &&
    css`
      padding: 20px;
      max-width: 1000px;

      @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
        padding: 0;
      }
    `}

  & > * {
    width: 100%;
  }
`;

export const AllCategoriesWrapper = styled.div`
  ${wrapperStyles};
`;

export const CategoryWrapper = styled.div`
  ${wrapperStyles};
`;

export const SubcategoryWrapper = styled.div`
  ${wrapperStyles};
`;

export const AllCategoriesContainer = styled.div<{ $isVipAds: boolean }>`
  ${containerStyles};
`;

export const CategoryContainer = styled.div<{ $isVipAds: boolean }>`
  ${containerStyles};
`;

export const SubcategoryContainer = styled.div<{ $isVipAds: boolean }>`
  ${containerStyles};
`;

export const layoutComponents = {
  'all-categories': {
    Wrapper: AllCategoriesWrapper,
    Container: AllCategoriesContainer,
  },
  category: {
    Wrapper: CategoryWrapper,
    Container: CategoryContainer,
  },
  subcategory: {
    Wrapper: SubcategoryWrapper,
    Container: SubcategoryContainer,
  },
} satisfies Record<
  AdsSectionLayoutScope,
  {
    Wrapper: typeof AllCategoriesWrapper;
    Container: typeof AllCategoriesContainer;
  }
>;

export const TitleBox = styled.div`
  padding: 20px 0 25px 0;
  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    padding: 10px 15px;
  }
`;

export const Title = styled.h1`
  display: inline;
  font-size: 24px;
  font-weight: 700;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    font-size: 18px;
  }
`;

export const AdsAmount = styled.span`
  font-size: 14px;
  font-weight: 400;
  color: ${({ theme }) => theme.palette.secondary.labels};
  margin-left: 10px;
  vertical-align: initial;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    font-size: 12px;
    margin-left: 5px;
  }
`;

export const AdsAmountSkeletonLoader = styled(SkeletonLoader).attrs({
  width: 40,
  height: 18,
  borderRadius: 7,
})`
  display: inline-block;
  margin-left: 10px;
  vertical-align: middle;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    margin-left: 5px;
  }
`;

export const FooterBox = styled.div<{ $isVisible: boolean }>`
  ${({ $isVisible }) => ($isVisible ? '' : HiddenElement)};
`;

export const Breadcrumbs = styled(BreadcrumbsComponent)`
  padding: 10px 0;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    padding: 10px 15px;
  }
`;

export const DesktopFooter = styled(DesktopFooterComponent)<{
  $isVipPage?: boolean;
}>`
  ${({ $isVipPage }) =>
    $isVipPage &&
    css`
      padding: 40px calc((100% - 1000px) / 2 + 20px) 15px;
    `}
`;
